/**
 * @returns {boolean} True if this is a custom domain
 */
export const isCustomDomain = (): boolean => {
    const hostname = window.location.hostname;
    // Check if this is the main domain
    if (hostname === 'statustrust.io' || hostname === 'www.statustrust.io') {
      return false;
    }
    
    // If a subdomain is detected, consider it a custom domain
    const account = getAccountFromSubdomain();
    return !!account && account !== 'test' && account !== 'statustrust';
  };

  
  export const getAccountFromSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
  
    if (parts.length < 3) {
      return null;
    }
  
    if (parts[0] === 'www') {
      return parts.length > 3 ? parts[1] : null;
    }
  
    return parts[0];
  };